<template>
  <b-modal
    ref="modal"
    title="Patients Imported Successfully!"
    size="lg"
    ok-only
    ok-title="OK"
    header-bg-variant="success"
    header-text-variant="white"
  >
    <div v-if="result">
      <div class="text-center mb-4">
        <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
      </div>
      <b-card bg-variant="light" class="mb-3">
        <h6 class="text-primary mb-3">
          <i class="fas fa-info-circle mr-2"></i>
          Import Details
        </h6>
        <dl class="row mb-0">
          <dt class="col-sm-5">Total Rows:</dt>
          <dd class="col-sm-7">{{ result.totalRows || 0 }}</dd>
          <dt class="col-sm-5">Filtered Empty Rows:</dt>
          <dd class="col-sm-7">{{ result.filteredEmptyRows || 0 }}</dd>
          <dt class="col-sm-5">Imported Count:</dt>
          <dd class="col-sm-7"><strong class="text-success">{{ result.importedCount || 0 }}</strong></dd>
          <template v-if="result.firstDN">
            <dt class="col-sm-5">First DN:</dt>
            <dd class="col-sm-7"><code>{{ result.firstDN }}</code></dd>
          </template>
          <template v-if="result.lastDN">
            <dt class="col-sm-5">Last DN:</dt>
            <dd class="col-sm-7"><code>{{ result.lastDN }}</code></dd>
          </template>
        </dl>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ImportResultModal',
  data() {
    return {
      result: null
    };
  },
  methods: {
    show(result) {
      this.result = result;
      this.$refs.modal.show();
    }
  }
};
</script>
